import { ForwardRefExoticComponent } from 'react';

import WrapperMockComponent from '@hh.ru/magritte-ui-icon/WrapperMockComponent';
import { mockComponent } from '@hh.ru/magritte-ui-mock-component';

export { type IconColor, type IconDisabledColor } from '@hh.ru/magritte-ui-icon/types';

export const IconDynamic: ForwardRefExoticComponent<Record<string, unknown>> = mockComponent('IconDynamic', undefined, {
    withChildren: true,
});
export const CheckmarkOutlinedCircledSize16 = mockComponent(
    'CheckmarkOutlinedCircledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CheckmarkOutlinedCircledSize24 = mockComponent(
    'CheckmarkOutlinedCircledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CheckmarkOutlinedSize16 = mockComponent(
    'CheckmarkOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CheckmarkOutlinedSize24 = mockComponent(
    'CheckmarkOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChevronArrowDiagonalUpRightFilledSize16 = mockComponent(
    'ChevronArrowDiagonalUpRightFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChevronArrowDiagonalUpRightFilledSize24 = mockComponent(
    'ChevronArrowDiagonalUpRightFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChevronArrowDownRightFilledSize16 = mockComponent(
    'ChevronArrowDownRightFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChevronArrowDownRightFilledSize24 = mockComponent(
    'ChevronArrowDownRightFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChevronArrowRightFilledSize16 = mockComponent(
    'ChevronArrowRightFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChevronArrowRightFilledSize24 = mockComponent(
    'ChevronArrowRightFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChevronGroup1FilledSize16 = mockComponent(
    'ChevronGroup1FilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChevronGroup1FilledSize24 = mockComponent(
    'ChevronGroup1FilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChevronGroup2FilledSize16 = mockComponent(
    'ChevronGroup2FilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChevronGroup2FilledSize24 = mockComponent(
    'ChevronGroup2FilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChevronGroup3FilledSize16 = mockComponent(
    'ChevronGroup3FilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ChevronGroup3FilledSize24 = mockComponent(
    'ChevronGroup3FilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CompanysLifeFilledSize16 = mockComponent(
    'CompanysLifeFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CompanysLifeFilledSize24 = mockComponent(
    'CompanysLifeFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CompanysLifeOutlinedCircledSize16 = mockComponent(
    'CompanysLifeOutlinedCircledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CompanysLifeOutlinedCircledSize24 = mockComponent(
    'CompanysLifeOutlinedCircledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CompanysLifeOutlinedSize16 = mockComponent(
    'CompanysLifeOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const CompanysLifeOutlinedSize24 = mockComponent(
    'CompanysLifeOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DreamjobCircledSize16 = mockComponent(
    'DreamjobCircledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DreamjobCircledSize24 = mockComponent(
    'DreamjobCircledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DreamjobSize16 = mockComponent(
    'DreamjobSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const DreamjobSize24 = mockComponent(
    'DreamjobSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmployersRatingFilledSize16 = mockComponent(
    'EmployersRatingFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmployersRatingFilledSize24 = mockComponent(
    'EmployersRatingFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmployersRatingOutlinedCircledSize16 = mockComponent(
    'EmployersRatingOutlinedCircledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmployersRatingOutlinedCircledSize24 = mockComponent(
    'EmployersRatingOutlinedCircledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmployersRatingOutlinedSize16 = mockComponent(
    'EmployersRatingOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const EmployersRatingOutlinedSize24 = mockComponent(
    'EmployersRatingOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HrBrandOutlinedCircledSize16 = mockComponent(
    'HrBrandOutlinedCircledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HrBrandOutlinedCircledSize24 = mockComponent(
    'HrBrandOutlinedCircledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HrBrandOutlinedSize16 = mockComponent(
    'HrBrandOutlinedSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const HrBrandOutlinedSize24 = mockComponent(
    'HrBrandOutlinedSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ItAccreditationCircledSize16 = mockComponent(
    'ItAccreditationCircledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ItAccreditationCircledSize24 = mockComponent(
    'ItAccreditationCircledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ItAccreditationFilledSize16 = mockComponent(
    'ItAccreditationFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ItAccreditationFilledSize24 = mockComponent(
    'ItAccreditationFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ItAccreditationSize16 = mockComponent(
    'ItAccreditationSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const ItAccreditationSize24 = mockComponent(
    'ItAccreditationSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LabelEyeFilledSize16 = mockComponent(
    'LabelEyeFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LabelEyeFilledSize24 = mockComponent(
    'LabelEyeFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LabelFlameFilledSize16 = mockComponent(
    'LabelFlameFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LabelFlameFilledSize24 = mockComponent(
    'LabelFlameFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LabelThumbFilledSize16 = mockComponent(
    'LabelThumbFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LabelThumbFilledSize24 = mockComponent(
    'LabelThumbFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LabelUserFilledSize16 = mockComponent(
    'LabelUserFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const LabelUserFilledSize24 = mockComponent(
    'LabelUserFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const OvalSplitFilledSize16 = mockComponent(
    'OvalSplitFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const OvalSplitFilledSize24 = mockComponent(
    'OvalSplitFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const QuestionFilledSize16 = mockComponent(
    'QuestionFilledSize16',
    { _size: 16, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);

export const QuestionFilledSize24 = mockComponent(
    'QuestionFilledSize24',
    { _size: 24, isIcon: true },
    {
        withChildren: false,
        WrapperComponent: WrapperMockComponent,
    }
);
